import { render, staticRenderFns } from "./HeatingConstructionYear.vue?vue&type=template&id=331f54b4"
import script from "./HeatingConstructionYear.vue?vue&type=script&lang=ts"
export * from "./HeatingConstructionYear.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports